export default {
    "regulations": {
        "titles": "Documentos",
        "title": "Documento",
        "label": "@:regulations.titles",
        "list": {
            "buttons": {
                "item": "Documento"
            }
        }
    },
}
